import React from "react"
import PropTypes from "prop-types"
import { amber500, green500 } from "material-ui/styles/colors"
import RaisedButton from "material-ui/RaisedButton"
import FlatButton from "material-ui/FlatButton"
import Dialog from "material-ui/Dialog"
import strings from "../../localization/strings"

const moment = require("moment")
const SignaturePad = require("react-signature-pad")

const propTypes = {
    startedItem: PropTypes.object,
    completedItem: PropTypes.bool,
    icon: PropTypes.string,
    startedTitle: PropTypes.string,
    completedTitle: PropTypes.string,
    onSignatureChange: PropTypes.func,
    onCompleteItemClick: PropTypes.func,
    requireSignature: PropTypes.func,
    signatureCompleted: PropTypes.bool,
    active: PropTypes.bool,
    ReviewInfo: PropTypes.element
}

export default class I9ProgressItem extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = this.getStateFromProps(props)
        this.signDoc = this.signDoc.bind(this)
        this.saveSignatureDialog = this.saveSignatureDialog.bind(this)
        this.closeSignatureDialog = this.closeSignatureDialog.bind(this)
        this.clearSigPad = this.clearSigPad.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.getStateFromProps(nextProps))
    }

    getStateFromProps(props) {
        return {
            startedItem: props.startedItem,
            completedItem: props.completedItem,
            icon: "fa " + props.icon + " fa-stack-1x fa-inverse",
            startedTitle: props.startedTitle,
            completedTitle: props.completedTitle,
            requireSignature: props.requireSignature,
            signatureCompleted: props.signatureCompleted,
            active: props.active
        }
    }

    requiredSignatureComplete() {
        if (!this.state.requireSignature) {
            return true
        }

        return this.state.signatureCompleted
    }

    showCompleted() {
        return this.state.completedItem // && this.requiredSignatureComplete();
    }

    clearSigPad() {
        this.refs.mySignature.clear()
    }

    signDoc() {
        this.setState(
            {
                showSignDialog: true
            },
            () => {
                this.refs.mySignature._canvas.width = 700
                this.refs.mySignature.penColor = "rgb(1, 73, 181)"
            }
        )
    }

    closeSignatureDialog() {
        this.setState({
            showSignDialog: false
        })
    }

    saveSignatureDialog() {
        this.setState(
            {
                showSignDialog: false,
                signatureImage: this.refs.mySignature.toDataURL()
            },
            () => {
                if (this.props.onSignatureChange) {
                    this.props.onSignatureChange(this.state.signatureImage)
                }
            }
        )
    }

    render() {
        if (!this.state.startedItem) {
            return null
        } else {
            return (
                <div className="i9-progress-item I9ProgressItem" style={{ width: "100%", textAlign: "center" }}>
                    <div>
                        {(() => {
                            if (this.state.active && this.state.startedItem) {
                                return (
                                    <div
                                        style={{
                                            padding: 3,
                                            borderTop: "solid 1px #e7e7e7"
                                        }}
                                    >
                                        {this.showCompleted() ? (
                                            <div>
                                                <div className="fa-stack fa-lg" style={{ fontSize: 15 }}>
                                                    <i
                                                        className="fa fa-circle fa-stack-2x"
                                                        style={{
                                                            color: green500
                                                        }}
                                                    />
                                                    <i className={this.state.icon} />
                                                </div>
                                                <div style={{ marginBottom: -5 }}>
                                                    <b>{this.state.completedTitle}</b>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className="fa-stack fa-lg" style={{ fontSize: 35 }}>
                                                    <i
                                                        className="fa fa-circle fa-stack-2x"
                                                        style={{
                                                            color: amber500
                                                        }}
                                                    />
                                                    <i className={this.state.icon} />
                                                </div>
                                                <div
                                                    style={{
                                                        marginTop: -15,
                                                        marginBottom: -15
                                                    }}
                                                >
                                                    <h3>{this.state.startedTitle}</h3>
                                                </div>
                                            </div>
                                        )}
                                        <div
                                            style={{
                                                fontSize: 10,
                                                color: "#aaaaaa"
                                            }}
                                        >
                                            {new moment(this.state.startedItem.EventDateTime).format("dddd MMM. DD, YYYY h:mm A").toString()}
                                        </div>
                                        {this.state.completedItem &&
                                            !this.requiredSignatureComplete() && (
                                                <div
                                                    style={{
                                                        padding: 5,
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    <RaisedButton
                                                        ref="button"
                                                        label="Review and Sign"
                                                        secondary={false}
                                                        style={{ width: 200 }}
                                                        icon={<i className="fa fa-hand-o-up" />}
                                                        onTouchTap={this.signDoc}
                                                    />
                                                </div>
                                            )}
                                        {!this.showCompleted() &&
                                            this.props.onCompleteItemClick && (
                                                <div
                                                    style={{
                                                        padding: 5,
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    <RaisedButton label="Complete Section" secondary={false} onTouchTap={this.props.onCompleteItemClick} />
                                                </div>
                                            )}
                                    </div>
                                )
                            }
                        })()}
                    </div>

                    <Dialog
                        title="Signature"
                        actions={[
                            <FlatButton label="Save" secondary={true} onTouchTap={this.saveSignatureDialog} />,
                            <FlatButton label={strings.Cancel} secondary={false} onTouchTap={this.closeSignatureDialog} />
                        ]}
                        modal={true}
                        open={this.state.showSignDialog}
                    >
                        {this.props.ReviewInfo}
                        <div
                            style={{
                                border: "dashed 1px #cccccc",
                                width: 700,
                                backgroundColor: "#f3f5f9"
                            }}
                            ref="sigPadDiv"
                        >
                            <SignaturePad ref="mySignature" />
                        </div>
                        <div>
                            <i className="fa fa-remove" /> Sign your name in the box above
                        </div>
                        <RaisedButton ref="button" label="Clear" secondary={false} style={{ width: 100, marginTop: 10 }} icon={<i className="fa fa-trash" />} onTouchTap={this.clearSigPad} />
                    </Dialog>
                </div>
            )
        }
    }
}

I9ProgressItem.propTypes = propTypes
